import React from 'react';
import './LegalAdvisor.css';
import servicesImage from '../../assets/images/Why choose us_.jpg';

const LegalAdvisor: React.FC = () => {
  

  return (
    <section className="legal-advisor-section">
      <div className="legal-advisor-container">
        {/* Left Section - Dark Teal */}
        <div className="legal-advisor-left">
          <div className="legal-advisor-header">
            <span className="legal-advisor-label">LEGAL ADVISOR</span>
            <span className="legal-advisor-icon-small">▢</span>
          </div>

          <h1 className="legal-advisor-title">
            Why<br />
            <span className="legal-advisor-title-italic">choose us?</span>
          </h1>

          {/* Hand holding scales graphic */}
          <div className="legal-advisor-graphic">
            <svg
              width="180"
              height="220"
              viewBox="0 0 180 220"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Hand - open palm, minimalist outline */}
              <path
                d="M90 20 C80 15, 65 12, 50 15 C40 18, 35 25, 38 35 C40 42, 48 48, 55 52 L65 60 C70 65, 75 72, 80 80 L85 90 C88 95, 90 100, 90 105 C90 100, 92 95, 95 90 L100 80 C105 72, 110 65, 115 60 L125 52 C132 48, 140 42, 142 35 C145 25, 140 18, 130 15 C115 12, 100 15, 90 20 Z"
                stroke="white"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              {/* Wrist */}
              <path
                d="M75 105 L90 110 L105 105"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              {/* Scales of Justice - centered in palm */}
              <g transform="translate(90, 130)">
                {/* Central pillar/base */}
                <line
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="35"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                {/* Crossbar */}
                <line
                  x1="-30"
                  y1="20"
                  x2="30"
                  y2="20"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                {/* Left scale pan */}
                <ellipse
                  cx="-30"
                  cy="20"
                  rx="12"
                  ry="4"
                  stroke="white"
                  strokeWidth="1.5"
                  fill="none"
                />
                {/* Right scale pan */}
                <ellipse
                  cx="30"
                  cy="20"
                  rx="12"
                  ry="4"
                  stroke="white"
                  strokeWidth="1.5"
                  fill="none"
                />
                {/* Chains/strings connecting to crossbar */}
                <line
                  x1="-30"
                  y1="20"
                  x2="-30"
                  y2="25"
                  stroke="white"
                  strokeWidth="1"
                />
                <line
                  x1="30"
                  y1="20"
                  x2="30"
                  y2="25"
                  stroke="white"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </div>

          {/* Services List */}
          <ul className="legal-advisor-services">
            <li>Best Legal Defence</li>
            <li>Skilled Attorneys</li>
            <li>Trust & Estates</li>
            <li>Civil Litigation</li>
          </ul>
        </div>

        {/* Center Section - Image */}
        <div className="legal-advisor-center">
          <div className="legal-advisor-image-wrapper">
            <img
              src={servicesImage}
              alt="Legal Services"
              className="legal-advisor-image"
            />
          </div>
        </div>

        {/* Right Section - Light Cream */}
        <div className="legal-advisor-right">
          <div className="legal-advisor-icon-top">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="40"
                height="40"
                fill="#0d1b2a"
                stroke="white"
                strokeWidth="1"
                rx="2"
              />
              {/* Gavel head */}
              <ellipse
                cx="20"
                cy="12"
                rx="8"
                ry="5"
                stroke="white"
                strokeWidth="1.5"
                fill="none"
              />
              {/* Gavel handle */}
              <line
                x1="20"
                y1="17"
                x2="20"
                y2="28"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              {/* Sound block */}
              <rect
                x="14"
                y="28"
                width="12"
                height="6"
                stroke="white"
                strokeWidth="1.5"
                fill="none"
                rx="1"
              />
            </svg>
          </div>

          <p className="legal-advisor-text-1">
            With our leading law firm in Coimbatore, India and expert lawyers, we deliver you top-tier representation across civil, property, consumer, arbitration, criminal, DRT, chit fund, insurance, banking and electricity law.</p>
          <p>We understand your legal challenges and demand personalized care, also our team provides dedicated guidance and gains deep knowledge about the case for each client’s unique goals to secure optimal results. </p>

          <div className="legal-advisor-divider"></div>

          <p className="legal-advisor-text-2">
           Our team of skilled negotiators and litigators with proven courtroom success will support and stay ahead of legal trends while deploying cutting-edge strategies for each of our client’s victories.</p>
           <p className="legal-advisor-text-3">Advocate Kannan’s exceptional service includes features like open communication, constant updates and prompt responsiveness to all your concerns. </p>
        </div>
      </div>
    </section>
  );
};

export default LegalAdvisor;

